import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

const get = (url, params) => api.get(url, { params }).then((r) => r.data);
const post = (url, body) => api.post(url, body).then((r) => r.data);
const put = (url, body) => api.put(url, body).then((r) => r.data);
const patch = (url, body) => api.patch(url, body).then((r) => r.data);
const del = (url) => api.delete(url).then((r) => r.data);

export const errMsg = (e, fallback = "Error del servidor") => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || fallback;
};

export const getMe = () => get("/auth/me");
export const logout = () => post("/auth/logout");

export const listConversations = (filter = "all", q = "", tag = "") =>
  get("/conversations", { filter, ...(q ? { q } : {}), ...(tag ? { tag } : {}) });
export const getConversation = (id) => get(`/conversations/${id}`);
export const sendAgentMessage = (id, text) => post(`/conversations/${id}/send`, { text });
export const toggleBot = (id, enabled) => post(`/conversations/${id}/bot`, { enabled });
export const claimConversation = (id) => post(`/conversations/${id}/claim`);
export const setTags = (id, tags) => put(`/conversations/${id}/tags`, { tags });
export const setNotes = (id, notes) => put(`/conversations/${id}/notes`, { notes });
export const listTags = () => get("/tags");

export const getBotSettings = () => get("/settings/bot");
export const updateBotPrompt = (prompt) => put("/settings/bot", { prompt });
export const generateBotPrompt = (ideas) => post("/settings/bot/generate", { ideas });
export const getWhatsAppStatus = () => get("/settings/whatsapp");
export const getWhatsAppCredentials = () => get("/settings/whatsapp/credentials");
export const saveWhatsAppCredentials = (body) => put("/settings/whatsapp/credentials", body);
export const checkWhatsAppConnection = () => post("/settings/whatsapp/check");

export const getBusiness = () => get("/business");
export const saveBusiness = (body) => put("/business", body);
export const getPromptPreview = () => get("/business/prompt-preview");

export const listProducts = () => get("/products");
export const createProduct = (body) => post("/products", body);
export const updateProduct = (id, body) => put(`/products/${id}`, body);
export const deleteProduct = (id) => del(`/products/${id}`);

export const listOrders = (params = {}) => get("/orders", params);
export const createOrder = (body) => post("/orders", body);
export const updateOrderStatus = (id, status) => patch(`/orders/${id}`, { status });
export const deleteOrder = (id) => del(`/orders/${id}`);

export const listQuickReplies = () => get("/quick-replies");
export const createQuickReply = (body) => post("/quick-replies", body);
export const updateQuickReply = (id, body) => put(`/quick-replies/${id}`, body);
export const deleteQuickReply = (id) => del(`/quick-replies/${id}`);

export const getStats = () => get("/stats");

export const getSimulator = (phone) => get("/simulator", { phone });
export const simSend = (body) => post("/simulator/message", body);
export const simReset = (phone) => post("/simulator/reset", { phone });

export const seedDemo = () => post("/demo/seed");
